import { render } from "./index.vue?vue&type=template&id=10cfa7f1"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=10cfa7f1&lang=css"
script.render = render

export default script